import { useState } from "react";

import { Input } from "@/src/components/ui/input";
import logo from "@/src/logo.svg";
import { Button } from "@/src/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useFetch } from "@/src/lib/useFetch";

const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

export function Login() {
  const [email, setEmail] = useState("");
  const [touched, setTouched] = useState(false);

  const error = !email.match(emailRegex);

  const navigate = useNavigate();
  const { fetch, isFetching } = useFetch();

  const onSend = async () => {
    setTouched(true);

    if (error) {
      return;
    }

    fetch("/api/auth/login-link-request", "POST", { email })
      .then(() => {
        navigate("/login/link-sent", {
          state: { email },
        });
      })
      .catch((err) => {
        console.error(err);
        navigate("/login/error");
      });
  };

  return (
    <div className="h-screen w-screen p-2 relative flex place-content-center bg-white">
      <img src={logo} className="absolute w-16 h-9 left-11 top-7"></img>
      <form
        className="flex flex-col items-center justify-center w-96"
        onSubmit={(ev) => {
          ev.preventDefault();
          onSend();
        }}
      >
        <h1 className="text-3xl font-semibold">Log in</h1>
        <span className="text-base mt-4">Enter your work e-mail to log in</span>
        <Input
          value={email}
          onChange={(ev) => setEmail(ev.currentTarget.value)}
          placeholder="Enter your work e-mail"
          className="mt-6"
        />
        <span className="text-red-600 mt-1 place-self-start inline-block h-6">
          {touched && error && "Please enter a valid email"}
        </span>
        <Button className="mt-5 w-full" type="submit" disabled={isFetching}>
          Send login link
        </Button>
      </form>
    </div>
  );
}
